import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "./assets/css/tailwind.generated.css";
import "./assets/css/master.less";
import "./assets/css/list.less";
import "./assets/css/common.less";
import "./assets/css/bootstrap.min.css";
import "./assets/font/iconfont.css";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
